import { Box, Typography } from '@mui/material';
import React from 'react';

import { SECTION_LABEL_SX, SECTION_LOCK_SX, SECTION_SUBLABEL_SX } from '../constants';

export interface SectionLabelProps {
  label: string;
  required?: boolean;
  helper?: string;
  lockReason?: string;
  locked?: boolean;
  children?: React.ReactNode;
}

export const SectionLabel: React.FC<SectionLabelProps> = ({
  label,
  required,
  helper,
  lockReason,
  locked,
  children,
}) => {
  const isLocked = !!lockReason || !!locked;
  return (
    <Box>
      <Typography
        sx={{
          ...SECTION_LABEL_SX,
          color: isLocked ? 'text.disabled' : undefined,
        }}
      >
        {label}
        {required ? ' *' : ''}
      </Typography>
      {lockReason ? (
        <Typography sx={SECTION_LOCK_SX}>{lockReason}</Typography>
      ) : (
        helper && <Typography sx={SECTION_SUBLABEL_SX}>{helper}</Typography>
      )}
      <Box
        aria-disabled={isLocked ? true : undefined}
        sx={{
          opacity: isLocked ? 0.55 : 1,
          pointerEvents: isLocked ? 'none' : 'auto',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
